import { render, staticRenderFns } from "./CovidCards.vue?vue&type=template&id=50370126&"
import script from "./CovidCards.vue?vue&type=script&lang=js&"
export * from "./CovidCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports